import { accommodationReservation } from './accommodationReservation';
import { group } from './group';
import { guideReservation } from './guideReservation';
import { stripperReservation } from './stripperReservation';
import { serviceReservationViewTable } from './serviceReservationViewTable';
import { activityReservationTable } from './activityReservationTable';
import { groupActivityReservationTable } from './groupActivityReservationTable';
import { serviceProvider } from './serviceProvider';
import { salesPartner } from './salesPartner';
import { activity } from './activity';
import { activityReservation } from './activityReservation';
import { accommodation } from './accommodation';

export const views: any = {
  accommodation_reservation: accommodationReservation(),
  accommodations: accommodation,
  accommodation_reservations: accommodation,
  group,
  groups: group,
  activity_reservation: activityReservationTable(),
  activity_reservations: activityReservation(),
  activities: activity,
  guide: guideReservation(),
  guides: guideReservation(),
  stripper: stripperReservation(),
  service: serviceReservationViewTable,
  service_reservations: serviceReservationViewTable,
  service_providers: serviceProvider,
  sales_partners: salesPartner,
  group_activity_reservation: groupActivityReservationTable(),
};
